(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["efa-page-contact"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reduit() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function init(root) {
    var dlg = root.querySelector('[data-efa-nc-dialog]');
    if (!dlg || dlg.getAttribute('data-efa-nc-bound') === '1') { return; }
    dlg.setAttribute('data-efa-nc-bound', '1');
    var minuteur = null;

    function annule() { if (minuteur) { clearTimeout(minuteur); minuteur = null; } }

    function ferme() {
      annule();
      if (reduit()) { dlg.classList.remove('-sort'); dlg.close(); return; }
      if (dlg.classList.contains('-sort')) { return; }
      dlg.classList.add('-sort');
      var fini = false;
      function fin() {
        if (fini) { return; }
        fini = true;
        dlg.classList.remove('-sort');
        dlg.close();
      }
      dlg.addEventListener('animationend', fin, { once: true });
      setTimeout(fin, 800);
    }

    function ouvre() {
      annule();
      dlg.classList.remove('-sort');
      if (typeof dlg.showModal === 'function') { dlg.showModal(); }
      else { dlg.setAttribute('open', ''); }
      var f = dlg.querySelector('input:not([type=hidden]), select, textarea, button');
      if (f) { f.focus(); }
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-efa-nc-open]'), function (b) {
      b.addEventListener('click', ouvre);
    });
    Array.prototype.forEach.call(dlg.querySelectorAll('[data-efa-nc-close]'), function (b) {
      b.addEventListener('click', ferme);
    });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) { ferme(); } });
    // Echap : on reprend la main pour animer la sortie au lieu de fermer sec
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); ferme(); });

    var ok = dlg.querySelector('[data-efa-nc-ok]');
    if (ok) {
      ouvre();
      // L'URL porte encore ?contact_posted=true#efa-nc-contact : telle quelle,
      // un rechargement rejouerait la confirmation d'un message que personne
      // n'a envoye, et le lien est partageable en l'etat. On la nettoie SANS
      // recharger, en preservant les autres parametres (apercu de theme).
      try {
        var u = new URL(window.location.href);
        if (u.searchParams.has('contact_posted') || u.hash) {
          u.searchParams.delete('contact_posted');
          var q = u.searchParams.toString();
          window.history.replaceState(null, '', u.pathname + (q ? '?' + q : ''));
        }
      } catch (e) {}
      var d = parseInt(dlg.getAttribute('data-efa-nc-delai'), 10);
      if (!(d > 0)) { d = 7000; }
      minuteur = setTimeout(ferme, reduit() ? 1500 : d);
    }
  }
  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.efa-nc'), init);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
